'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __chunk_1 = require('../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var __chunk_5 = require('../../lib/getScriptSource.js');

const Script = (_ref) => {
  let {
    src,
    extension,
    version,
    isCustomTemplate
  } = _ref,
      otherProps = __chunk_1.objectWithoutProperties(_ref, ["src", "extension", "version", "isCustomTemplate"]);

  if (!src && (!extension || !version)) return null;
  const props = src ? otherProps : __chunk_1.objectSpread({}, otherProps, {
    [`custom-${isCustomTemplate ? 'template' : 'element'}`]: extension
  });
  return React__default.createElement("script", __chunk_1.extends({
    async: true
  }, props, {
    src: __chunk_5.default({
      src,
      extension,
      version
    })
  }));
};

Script.defaultProps = {
  src: '',
  extension: '',
  version: 'latest',
  isCustomTemplate: false,
  id: undefined,
  nonce: undefined,
  type: undefined
};
Script.propTypes = {
  src: PropTypes.string,
  extension: PropTypes.string,
  version: PropTypes.string,
  isCustomTemplate: PropTypes.bool,
  id: PropTypes.string,
  nonce: PropTypes.string,
  type: PropTypes.string
};

exports.default = Script;
//# sourceMappingURL=Script.js.map
